<template>
  <!-- 能源分项 -->
  <span class="apphome" style="display: flex; width: 100%;">
    <el-row :gutter="10" style="width: 100%;">
      <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6" style="height: 90%;">
        <!-- 绑定设备 -->
        <transition name="el-zoom-in-center">
          <div class="apphome_box">
            <span
              style="font-size: 16px;font-weight: bold;transform: translateY(-10px);
            display: flex; align-items: center;"
              ><img
                src="../../assets/rateTemplate/组.png"
                alt=""
                style="margin-right:5px"
              />
              能耗配置单位</span
            >
            <span class="search">
              <span
                style="display: flex;white-space: nowrap;align-items: center;"
              >
                <span>筛选：</span>
                <el-input
                  v-model="filterText"
                  placeholder="输入关键字进行过滤"
                  clearable
                ></el-input>
              </span>
            </span>
            <div class="right-tree" style="padding-left:10px;height:90%">
              <el-scrollbar style="height:100%;width: 100%">
                <el-tree
                  :data="companyData"
                  node-key="unitNo"
                  :props="defaultPropsCompany"
                  :filter-node-method="filterNode"
                  default-expand-all
                  @node-click="nodeClick"
                  ref="Companytree"
                >
                  <span
                    class="custom-tree-node"
                    slot-scope="{ node, data }"
                    style="display: flex;align-items: center;"
                  >
                    <img src="../../assets/rateTemplate/公司.png" />
                    <span style="padding-left: 5px;">{{ data.name }}</span>
                  </span>
                </el-tree>
              </el-scrollbar>
            </div>
          </div>
        </transition>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="9" :xl="9" style="height: 90%;">
        <!-- 绑定设备 -->
        <transition name="el-zoom-in-center">
          <div class="apphome_box">
            <span
              style="font-size: 16px;font-weight: bold;transform: translateY(-10px);
            display: block;"
              >绑定设备（{{
                checkName == "" ? "请选择单位" : checkName
              }}）</span
            >
            <span class="search">
              <span
                style="display: flex;white-space: nowrap;align-items: center;"
              >
                <span>筛选：</span>
                <el-input
                  v-model="filterText"
                  placeholder="输入关键字进行过滤"
                  clearable
                ></el-input>
              </span>
              <!-- <el-button type="primary" icon="el-icon-search" @click="getDevice" :loading="loading">查询</el-button> -->
              <el-button
                type="primary"
                @click="saveDevice"
                style="margin-left:10px"
                >绑定</el-button
              >
              <!-- @click="saveDevice" -->
            </span>
            <div class="right-tree" style="padding-left:10px;height:90%">
              <el-scrollbar style="height:100%;width: 100%">
                <el-tree
                  :data="companyData"
                  node-key="unitNo"
                  :props="defaultPropsCompany"
                  :filter-node-method="filterNode"
                  default-expand-all
                  @node-click="nodeClick"
                  ref="Companytree"
                >
                  <span
                    class="custom-tree-node"
                    slot-scope="{ node, data }"
                    style="display: flex;align-items: center;"
                  >
                    <img src="../../assets/rateTemplate/公司.png" />
                    <span style="padding-left: 5px;">{{ data.name }}</span>
                  </span>
                </el-tree>
              </el-scrollbar>
            </div>
          </div>
        </transition>
      </el-col>
      <!-- 已绑定设备列表 -->
      <el-col :xs="24" :sm="24" :md="24" :lg="9" :xl="9" style="height: 90%;">
        <transition name="el-zoom-in-center">
          <!-- <subareabuild v-if="jianzhu" :mainId='mainId' ref="child"></subareabuild> -->
          <div class="apphome_box">
            <span
              style="font-size: 16px;font-weight: bold;transform: translateY(-10px);
            display: block;"
              >设备列表（{{
                checkName == "" ? "请选择单位" : checkName
              }}）</span
            >
            <span class="search">
              <span
                style="display: flex;white-space: nowrap;align-items: center;"
              >
                <span>搜索：</span>
                <el-input
                  v-model="searchName"
                  placeholder="请输入名称"
                  clearable
                ></el-input>
              </span>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="search_fn"
                style="margin-left:10px"
                plain
                >查询</el-button
              >
              <el-button type="danger" @click="device_Del">移除</el-button>
            </span>
            <div style="display: flex;">
              <div class="mytable">
                <el-table
                  ref="multipleTable"
                  :data="deviceTableData"
                  tooltip-effect="dark"
                  style="width: 100%"
                  max-height="800"
                  border
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column width="50" align="center">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column type="selection" width="50">
                  </el-table-column>
                  <el-table-column label="设备号" width="80">
                    <template slot-scope="scope">{{
                      scope.row.deviceno
                    }}</template>
                  </el-table-column>
                  <el-table-column prop="devicename" label="设备名称">
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </transition>
      </el-col>
    </el-row>
  </span>
</template>
<script>
//   import { EnergySubitem, GetEnergySubitem, EnergySubitemAdd, EnergySubitemDelete, EnergySubitemEdit, EnergySubitemAll, GetEnergySubitemVirtualDevice, SaveEnergySubitemVirtualDevice } from "@/utils/request";
//   import request from "@/utils/request";
//   import { parseTime } from "@/utils";
import Pagination from "../../components/module/Pagination"; // 分页
import { getReadDeviceTree } from "../../api/abbNewApi";
import {
  loadPowerSaveLoadPower,
  loadPowerDeleteLoadPower,
  findLoadPowerByGroupNo,
} from "../../api/loadPower";
export default {
  components: { Pagination },
  data() {
    return {
      heights: document.body.clientHeight - 18,
      mainId: "",
      topLevel: 0,
      deviceName: "",
      searchName: "",
      multipleSelection: [],
      deviceTableData: [
        {
          deviceno: 3,
          devicename: "永兴旺",
        },
        {
          deviceno: 11,
          devicename: "总进线数显表",
        },
        {
          deviceno: 13,
          devicename: "水侵",
        },
        {
          deviceno: 22,
          devicename: "益大",
        },
      ],
      companyData: [],
      checkedNodes: [],
      filterText: "",
      deviceData: [],
      defaultProps: {
        children: "ChildDatas",
        label: "Content.Name",
      },
      defaultPropsCompany: {
        children: "next",
        label: "name",
      },
      checkName: "",
    };
  },
  mounted() {
    // console.log("打卡时间内", this.$store.unitStore.getters.getUnitTree);
    this.companyData = [this.$store.unitStore.getters.getUnitTree];
    //获取设备树
    getReadDeviceTree().then((res) => {
      var recursiveFunction = function() {
        const getStr = function(list) {
          list.forEach(function(row) {
            if (row.ChildDatas.length != 0) {
              // console.log("row.ChildDatas",row);
              getStr(row.ChildDatas);
            } else {
              row["disabled"] = false;
            }
          });
        };
        getStr(res.data);
      };
      recursiveFunction();
      this.totalDeviceData = res.data;
      // this.companyData = res.data
      // console.log("设备列表",this.deviceData);
    });
  },
  methods: {
    //单位树点击事件
    nodeClick(item) {
      // console.log(item);
      this.mainId = item.unitNo;
      this.checkName = item.name;
      var a = this.totalDeviceData;
      var deviceData = [];
      var recursiveFunction = function() {
        const getStr = function(list) {
          list.forEach(function(row) {
            if (row.Content.Category == "Organization") {
              if (row.Content.Name == item.name) {
                deviceData = [row];
              }
              getStr(row.ChildDatas);
            }
          });
        };
        getStr(a);
      };
      recursiveFunction();
      this.deviceData = deviceData;
      this.getDevice();
    },
    //树形结构选中节点
    currentChecked(nodeObj, SelectedObj) {
      this.checkedNodes = SelectedObj.checkedNodes;
      this.checkedNodes = this.checkedNodes.filter(
        (item) => item.Content.Category == "Device"
      );
    },
    // 绑定设备
    saveDevice() {
      if (this.checkName == "") {
        this.$message({ type: "warning", message: "请选择单位" });
        return;
      }
      if (this.checkedNodes.length == 0) {
        this.$message({ type: "warning", message: "请勾选设备" });
        return;
      }
      var ids = "";
      this.checkedNodes.forEach((item) => (ids += "," + item.Id));
      ids = ids.slice(1);
      var d = {
        appType: "power",
        deviceNos: ids,
        groupNo: this.mainId,
      };
      loadPowerSaveLoadPower(d).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          //  this.checkedNodes = []
          this.$message({ type: "success", message: "绑定成功" });
          this.$refs.tree.setCheckedKeys([]);
          this.getDevice();
        } else {
          this.$message({ type: "error", message: `绑定失败,${res.message}` });
        }
      });
    },
    //输入关键字进行过滤
    filterNode(value, data) {
      if (!value) return true;
      return data.Content.Name.indexOf(value) !== -1;
    },

    //移除分项的关联设备
    device_Del() {
      if (this.checkName == "") {
        this.$message({ type: "warning", message: "请选择单位" });
        return;
      }
      // console.log("this.multipleSelection",this.multipleSelection);
      if (this.multipleSelection.length == 0) {
        this.$message({ type: "warning", message: "请勾选需要删除的设备!" });
        return;
      }
      var ids = "";
      this.multipleSelection.forEach((item) => (ids += "," + item.id));
      // console.log(ids.split(1));
      ids = ids.slice(1);
      //  'subitemId':this.mainId,
      var d = {
        loadPowerId: ids,
      };
      console.log(d);
      loadPowerDeleteLoadPower(d).then((res) => {
        // console.log("移除",res);
        if (res.code == 200) {
          this.$message({ type: "success", message: "移除成功!" });
          this.getDevice();
        } else {
          this.$message({ type: "error", message: `移除失败,${res.message}` });
        }
      });
    },
    //搜索设备列表
    search_fn() {},

    // 获取绑定列表
    getDevice() {
      var d = {
        appType: "power",
        groupNo: this.mainId,
      };
    },
    // 勾选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-scrollbar__wrap {
  overflow-x: hidden;
}

/deep/.el-scrollbar__view {
  width: 100%;
}

.select_tree {
  .el-tree-node {
    .is-leaf + .el-checkbox .el-checkbox__inner {
      display: inline-block;
    }

    .el-checkbox__input > .el-checkbox__inner {
      display: none;
    }
  }
}
</style>
<style lang="scss" scoped>
.apphome {
  padding: 15px;
}

/deep/.el-tree-node:focus > .el-tree-node__content {
  background-color: #ddedff;
}

.apphome_box {
  background-color: #fff;
  padding: 20px;
  margin-bottom: 10px;
  //  min-height: calc(100vh - 130px);
  //   max-height: calc(100vh - 130px);
  height: 97%;
  position: relative;
}

.spaned {
  display: flex;
  flex-wrap: wrap;
}

.band {
  color: red;
  padding-left: 20px;
  font-size: 12px;
  margin-bottom: 5px;
}

.mytable {
  width: 100%;

  /deep/.el-table th {
    background-color: #f1f8ff;
  }
}

.actived {
  color: red;
}

.search {
  margin-bottom: 12px;
  display: flex;
  // justify-content: space-between;
  align-items: center;
}

.avatar {
  width: 30px;
  height: 30px;
  object-fit: cover;
}

.el-icon-d-arrow-left {
  position: absolute;
  right: 0;
  top: 300px;
  z-index: 1;
  font-size: 28px;
  cursor: pointer;
  background: #d7d7d7;
  clip-path: polygon(
    -18px 35px,
    26px 100%,
    calc(100% - 1px) 100%,
    calc(100% - 0px) 0
  );
  height: 70px;
  line-height: 70px;
  color: #666;
}

.el-icon-d-arrow-right {
  position: absolute;
  left: 0;
  top: 300px;
  z-index: 1;
  font-size: 28px;
  cursor: pointer;
  background: #d7d7d7;
  clip-path: polygon(
    0 0,
    1px 100%,
    calc(100% - 26px) 100%,
    calc(100% - -27px) 31px
  );
  height: 70px;
  line-height: 70px;
  color: #666;
}

.wrapper {
  width: 100%;
  height: 500px;
}

.pagination_box {
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
}
</style>
